import _ from 'lodash'
import UiStateContainer from '@vzmi/ec-react-ui-state-container'
import { ProposalSection, Toast, FormLoader } from '@vzmi/shp_shared_compo'
import { useQueryString } from '@vzmi/shp_shared_compo/dist/hook/useQueryString.js'
import useBackgroundFormDataOnInit from '../hook/useBackgroundFormDataOnInit'
import { withI13nWrapper } from '../../Common/I13nWrapper'
import Background from '../Common/Background'
import { withCommonPageErrorBoundary } from '../../Common/HOC/withErrorBoundary'
import BackToListingQueryLink from '../Common/BackToListingQueryLink'
import ContentLayout from '../Common/ContentLayout'
import withUpdateListingForm from '../../Proposal/Common/HOC/withUpdateListingForm'
import HeadingWithId from '../../Proposal/Common/HeadingWithId/HeadingWithId'
import useBatchProposalById from './useBatchProposalById'
import ListingImageRows from '../UpdateImage/ListingImageRows'
import { getBatchResult, getListingsWithProposal } from '../helper/batch'
import { getListingWithImagesModels } from '../UpdateImage/helper'
import ScheduledStatus from '../Common/ScheduledStatus'

const BatchUpdateImageOverview = (props) => {
  const {
    proposalType,
    name,
    actions,
    flags,
    user,
    initialize,
    change
  } = props
  const proposalId = useQueryString(global.window, 'id', true)
  const {
    isBatchProposalLoading,
    isDependencyRequestLoading,
    batchProposal,
    proposals = []
  } = useBatchProposalById(
    actions.fetchBatchProposal,
    actions.fetchMultipleProposals,
    actions.fetchListings,
    {
      onError: errorMessage => Toast.error(errorMessage),
      onSuccess: result => {
        const newProposals = _.get(result, 'proposals', [])
        const newBatchResult = getBatchResult(
          _.map(newProposals, proposal => ([undefined, proposal]))
        )
        const newListings = _.get(result, 'listings', [])
        const convertedListings = _.flow(
          () => getListingsWithProposal(newListings, newBatchResult),
          listingsWithProposalId => _.map(listingsWithProposalId, getListingWithImagesModels)
        )()
        change('listings', convertedListings)
      }
    }
  )
  const batchResult = getBatchResult(
    _.map(proposals, proposal => ([undefined, proposal]))
  )

  // 頁面初始化寫入賣場背景資料
  useBackgroundFormDataOnInit(props, initialize)

  return (
    <ContentLayout>
      <FormLoader
        isLoading={isBatchProposalLoading || isDependencyRequestLoading}
        fixed
      >
        <HeadingWithId
          title={name}
          subtitle={`批次編號：${proposalId}`}
        />
        <ScheduledStatus
          proposals={proposals}
          batch={batchProposal}
          batchResult={batchResult}
        />
        <Background
          flags={flags}
          user={user}
          isEditPage={false}
          readOnly
        />
        <ProposalSection title='賣場/商品圖片'>
          {!isDependencyRequestLoading && (
            <UiStateContainer>
              <ListingImageRows
                batchResult={batchResult}
                proposalType={proposalType}
                defaultExpanded={false}
                isOverviewPage
                readOnly
              />
            </UiStateContainer>
          )}
        </ProposalSection>
      </FormLoader>
    </ContentLayout>
  )
}

const hoc = _.flow(
  withI13nWrapper,
  // common page: yahoo title & supplier part
  // error boundary
  withCommonPageErrorBoundary(<BackToListingQueryLink />),
  // proposal redux form init
  withUpdateListingForm
)

export default hoc(BatchUpdateImageOverview)
